var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconos32PxFase2B1Generic01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{isolation:isolate;}.cls-3{opacity:0.2;}.cls-4{fill:url(#linear-gradient);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#5d6165;}.cls-7{fill:url(#linear-gradient-3);}.cls-8{fill:#555f64;}.cls-9{clip-path:url(#clip-path);}.cls-10{fill:#7e8d95;}.cls-11{fill:#9b9b9b;}.cls-12{fill:#4c4c4c;}.cls-13{fill:#b3b3b3;}.cls-14{fill:url(#linear-gradient-4);}.cls-15{fill:url(#linear-gradient-5);}.cls-16{fill:url(#linear-gradient-6);}.cls-17{fill:url(#linear-gradient-7);}.cls-18{fill:url(#linear-gradient-8);}.cls-19{fill:url(#linear-gradient-9);}.cls-20{fill:url(#linear-gradient-10);}.cls-21{fill:#f2f2f2;}.cls-22{fill:url(#linear-gradient-11);}.cls-23{fill:url(#linear-gradient-12);}.cls-24{fill:url(#linear-gradient-13);}.cls-25{fill:#e6e6e6;}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:#383838;}.cls-28{fill:url(#linear-gradient-15);}.cls-29{fill:url(#linear-gradient-16);}.cls-30{fill:url(#linear-gradient-17);}.cls-31{fill:url(#linear-gradient-18);}.cls-32{fill:url(#linear-gradient-19);}.cls-33{fill:url(#linear-gradient-20);}.cls-34{fill:url(#linear-gradient-21);}.cls-35{fill:url(#linear-gradient-22);}.cls-36{fill:url(#linear-gradient-23);}.cls-37{fill:#888;}.cls-38{fill:#afafaf;}.cls-39{fill:#c3c3c3;}.cls-40{fill:url(#linear-gradient-24);}.cls-41{fill:url(#linear-gradient-25);}.cls-42{fill:url(#linear-gradient-26);}.cls-43{fill:url(#linear-gradient-27);}.cls-44{fill:#d9d9d9;}.cls-45{fill:#a85919;}.cls-46{fill:#464a4f;}.cls-47{fill:#00060d;}.cls-48{fill:url(#linear-gradient-28);}.cls-49{fill:url(#linear-gradient-29);}.cls-50{opacity:0.7;}.cls-51{fill:#009ccd;}.cls-52{fill:#242424;}.cls-53{fill:url(#linear-gradient-30);}.cls-54{fill:#ccc;}.cls-119,.cls-122,.cls-123,.cls-55{mix-blend-mode:multiply;}.cls-56{clip-path:url(#clip-path-2);}.cls-123,.cls-57{fill:#1093c9;}.cls-122,.cls-58{fill:red;}.cls-59{fill:#171d23;}.cls-60{fill:url(#linear-gradient-31);}.cls-61{fill:url(#linear-gradient-32);}.cls-62{fill:url(#linear-gradient-33);}.cls-63{fill:url(#linear-gradient-34);}.cls-64{fill:url(#linear-gradient-35);}.cls-65{fill:url(#linear-gradient-36);}.cls-66{fill:url(#linear-gradient-37);}.cls-67{fill:url(#linear-gradient-38);}.cls-68{fill:url(#linear-gradient-39);}.cls-69{fill:url(#linear-gradient-40);}.cls-70{fill:url(#linear-gradient-41);}.cls-71{fill:url(#linear-gradient-42);}.cls-72{fill:url(#linear-gradient-43);}.cls-73{fill:url(#linear-gradient-44);}.cls-74{fill:url(#linear-gradient-45);}.cls-75{fill:url(#linear-gradient-46);}.cls-76{fill:url(#linear-gradient-47);}.cls-77{fill:url(#linear-gradient-48);}.cls-78{fill:url(#linear-gradient-49);}.cls-79{fill:url(#linear-gradient-50);}.cls-80{fill:url(#linear-gradient-51);}.cls-81{fill:url(#linear-gradient-52);}.cls-82{fill:url(#linear-gradient-53);}.cls-83{fill:url(#linear-gradient-54);}.cls-84{fill:url(#linear-gradient-55);}.cls-85{fill:url(#linear-gradient-56);}.cls-86{fill:url(#linear-gradient-57);}.cls-87{fill:url(#linear-gradient-58);}.cls-88{fill:url(#linear-gradient-59);}.cls-89{fill:url(#linear-gradient-60);}.cls-90{fill:url(#linear-gradient-61);}.cls-91{fill:url(#linear-gradient-62);}.cls-92{fill:url(#linear-gradient-63);}.cls-93{fill:url(#linear-gradient-64);}.cls-94{fill:url(#linear-gradient-65);}.cls-95{fill:url(#linear-gradient-66);}.cls-96{fill:url(#linear-gradient-67);}.cls-97{fill:url(#linear-gradient-68);}.cls-98{fill:url(#linear-gradient-69);}.cls-99{fill:url(#linear-gradient-70);}.cls-100{fill:url(#linear-gradient-71);}.cls-101{fill:url(#linear-gradient-72);}.cls-102{fill:url(#linear-gradient-73);}.cls-103{fill:url(#linear-gradient-74);}.cls-104{fill:url(#linear-gradient-75);}.cls-105{fill:url(#linear-gradient-76);}.cls-106{fill:url(#linear-gradient-77);}.cls-107{fill:#3d4248;}.cls-108{fill:url(#linear-gradient-78);}.cls-109{fill:#fdfdfd;}.cls-110{fill:#901b2b;}.cls-111{fill:#780414;}.cls-112{fill:#850416;}.cls-113{fill:#202020;}.cls-114{fill:#f07f24;}.cls-115{fill:#606060;}.cls-116{fill:#2e2e2e;}.cls-117{fill:url(#linear-gradient-79);}.cls-118{fill:url(#linear-gradient-80);}.cls-119{fill:url(#linear-gradient-81);}.cls-120{fill:url(#linear-gradient-82);}.cls-121{fill:url(#linear-gradient-83);}.cls-124{fill:url(#linear-gradient-84);}.cls-125{fill:url(#linear-gradient-85);}.cls-126{fill:url(#linear-gradient-86);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.32,
    y1: 42.33,
    x2: 2.58,
    y2: 44.76,
    gradientTransform: "matrix(1, 0.08, -0.08, 1, 4.53, -23.32)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1093c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#108ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#1080c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.05,
    y1: 24.38,
    x2: 11.77,
    y2: 24.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1093c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#108ac5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#107fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 23.53,
    y1: 15.04,
    x2: 23.68,
    y2: 14.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#464a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3d4147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.69,13.86,19.36,9.6l2.26-.83L29,13Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 23.75,
    y1: 16.82,
    x2: 24.47,
    y2: 15.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#2e3339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#252a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0d1319"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00060d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 27.19,
    y1: 17.16,
    x2: 27.34,
    y2: 16.91,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 27.19,
    y1: 20.89,
    x2: 25.84,
    y2: 18.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 27.19,
    y1: 20.88,
    x2: 25.85,
    y2: 18.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 27.18,
    y1: 20.86,
    x2: 25.86,
    y2: 18.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 24.59,
    y1: 20.81,
    x2: 26.5,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 26.92,
    y1: 20.41,
    x2: 26.12,
    y2: 19.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#999"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 25.73,
    y1: 20.41,
    x2: 26.72,
    y2: 18.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 25.72,
    y1: 20.4,
    x2: 26.72,
    y2: 18.68,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 25.85,
    y1: 20.47,
    x2: 26.84,
    y2: 18.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ccc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 26.26,
    y1: 20.39,
    x2: 26.16,
    y2: 20.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 26.49,
    y1: 19.4,
    x2: 26.4,
    y2: 19.24,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 26.79,
    y1: 20.28,
    x2: 26.7,
    y2: 20.12,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 26.5,
    y1: 20.45,
    x2: 26.4,
    y2: 20.29,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 26.16,
    y1: 20.12,
    x2: 26.07,
    y2: 19.96,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 26.79,
    y1: 19.23,
    x2: 26.7,
    y2: 19.07,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 26.25,
    y1: 19.74,
    x2: 26.16,
    y2: 19.58,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 27.03,
    y1: 19.94,
    x2: 26.94,
    y2: 19.78,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 27.12,
    y1: 19.56,
    x2: 27.03,
    y2: 19.4,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 27.03,
    y1: 19.29,
    x2: 26.94,
    y2: 19.13,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 24.22,
    y1: 20.98,
    x2: 26.62,
    y2: 16.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#2e3339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#464a4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 26.86,
    y1: 20.1,
    x2: 25.62,
    y2: 17.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#252a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 20.55,
    y1: 18.86,
    x2: 22.96,
    y2: 14.69,
    xlinkHref: "#linear-gradient-24"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 28.96,
    y1: 18.64,
    x2: 27.57,
    y2: 16.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00060d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#090f15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1d2329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2a2f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -4001.89,
    y1: -15527.05,
    x2: -3996,
    y2: -15529.2,
    gradientTransform: "translate(-2603.56 -15808.36) rotate(-175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17a5d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#17a5d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#74c9e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17a5d2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 22.06,
    y1: 9.05,
    x2: 24.27,
    y2: 5.22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 25.91,
    y1: 14.46,
    x2: 25.06,
    y2: 12.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,13c0-.08,0-.1-.14-.07l-.44.16-.16-2.22.42-.24.31-.18v-.31l-.07-.29h-.14L25,12.56a.53.53,0,0,0-.25.3L24.62,16l0,.7L24.53,18l1.14-.66,1.18-.68-.44.25h0l.56-.32c.21-.12.31-.11.41-.06l.39.19a.28.28,0,0,0,.32,0l1.07-.62.43-.25.29-.16,0,0,.1-.06Zm-3.32.88V12.23L28.86,11,29,13Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 21.94,
    y1: 22.66,
    x2: 21.03,
    y2: 21.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00060d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 11.19,
    y1: 21.17,
    x2: 11.74,
    y2: 20.22,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 11.94,
    y1: 23.59,
    x2: 10.59,
    y2: 21.25,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 11.93,
    y1: 23.58,
    x2: 10.59,
    y2: 21.26,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 11.92,
    y1: 23.56,
    x2: 10.6,
    y2: 21.28,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 9.33,
    y1: 23.51,
    x2: 11.24,
    y2: 20.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 11.66,
    y1: 23.11,
    x2: 10.86,
    y2: 21.73,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 10.47,
    y1: 23.11,
    x2: 11.46,
    y2: 21.39,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 10.47,
    y1: 23.1,
    x2: 11.46,
    y2: 21.39,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 10.59,
    y1: 23.17,
    x2: 11.58,
    y2: 21.46,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 11,
    y1: 23.08,
    x2: 10.91,
    y2: 22.93,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 11.24,
    y1: 22.1,
    x2: 11.14,
    y2: 21.94,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 11.54,
    y1: 22.98,
    x2: 11.44,
    y2: 22.82,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 11.24,
    y1: 23.15,
    x2: 11.15,
    y2: 22.99,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 10.91,
    y1: 22.81,
    x2: 10.82,
    y2: 22.66,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 11.53,
    y1: 21.93,
    x2: 11.44,
    y2: 21.77,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 11,
    y1: 22.44,
    x2: 10.91,
    y2: 22.28,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 11.78,
    y1: 22.64,
    x2: 11.68,
    y2: 22.48,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 11.87,
    y1: 22.26,
    x2: 11.78,
    y2: 22.1,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 11.77,
    y1: 21.99,
    x2: 11.68,
    y2: 21.83,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 8.47,
    y1: 23.17,
    x2: 8.48,
    y2: 23.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00060d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 8.54,
    y1: 23.19,
    x2: 10.8,
    y2: 19.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2e3339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#373c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#464a4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#44484d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#3d4247"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#32363c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 11.53,
    y1: 22.8,
    x2: 10.41,
    y2: 20.86,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 16.31,
    y1: 24.11,
    x2: 16.86,
    y2: 23.16,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 17.06,
    y1: 26.53,
    x2: 15.7,
    y2: 24.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 17.05,
    y1: 26.52,
    x2: 15.71,
    y2: 24.21,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 17.04,
    y1: 26.51,
    x2: 15.72,
    y2: 24.22,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 14.45,
    y1: 26.46,
    x2: 16.36,
    y2: 23.14,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 16.78,
    y1: 26.06,
    x2: 15.98,
    y2: 24.67,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 15.59,
    y1: 26.05,
    x2: 16.58,
    y2: 24.33,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 15.59,
    y1: 26.05,
    x2: 16.58,
    y2: 24.33,
    xlinkHref: "#linear-gradient-11"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 15.71,
    y1: 26.12,
    x2: 16.7,
    y2: 24.4,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 16.12,
    y1: 26.03,
    x2: 16.03,
    y2: 25.87,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 16.36,
    y1: 25.04,
    x2: 16.26,
    y2: 24.88,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 16.66,
    y1: 25.92,
    x2: 16.56,
    y2: 25.76,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 16.36,
    y1: 26.09,
    x2: 16.27,
    y2: 25.93,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 16.03,
    y1: 25.76,
    x2: 15.93,
    y2: 25.6,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 16.65,
    y1: 24.87,
    x2: 16.56,
    y2: 24.71,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 16.12,
    y1: 25.38,
    x2: 16.02,
    y2: 25.22,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 16.89,
    y1: 25.58,
    x2: 16.8,
    y2: 25.42,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 16.99,
    y1: 25.2,
    x2: 16.89,
    y2: 25.05,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 16.89,
    y1: 24.93,
    x2: 16.8,
    y2: 24.78,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 13.59,
    y1: 26.12,
    x2: 13.6,
    y2: 26.09,
    xlinkHref: "#linear-gradient-51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 13.66,
    y1: 26.13,
    x2: 15.92,
    y2: 22.22,
    xlinkHref: "#linear-gradient-52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 16.65,
    y1: 25.75,
    x2: 15.53,
    y2: 23.81,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 11.76,
    y1: 18.58,
    x2: 12.19,
    y2: 18.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#1d2329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2a2f35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#2e3339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#252a30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171d23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 10.64,
    y1: 23.89,
    x2: 10.93,
    y2: 23.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#171d23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#2e3339"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 15.05,
    y1: 25.67,
    x2: 14.57,
    y2: 24.84,
    xlinkHref: "#linear-gradient-31"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 14.16,
    y1: 20.67,
    x2: 14.34,
    y2: 20.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5c5c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#4f4f4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#383838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 14.39,
    y1: 20.69,
    x2: 14.4,
    y2: 20.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#383838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#606060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 16.81,
    y1: 13.01,
    x2: 24.05,
    y2: 13.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#eaeaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 10.96,
    y1: 27.61,
    x2: 4.71,
    y2: 13.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 8.84,
    y1: 11.04,
    x2: 21.14,
    y2: 22.54,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 5.08,
    y1: 25.61,
    x2: 11.96,
    y2: 23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 442.49,
    y1: -281.68,
    x2: 444.76,
    y2: -281.68,
    gradientTransform: "translate(441.56 314.53) rotate(-113.37)",
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 446.02,
    y1: -282.13,
    x2: 443.82,
    y2: -282.28,
    gradientTransform: "translate(441.56 314.53) rotate(-113.37)",
    xlinkHref: "#linear-gradient-29"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ICONOS-32PX-FASE-2b.1-GENERIC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,25.79A.94.94,0,0,1,5,24l14.86-8.79a3.4,3.4,0,0,1,3.08,0l4.56,2.65a.94.94,0,0,1,0,1.78L12.62,28.45a3.41,3.41,0,0,1-3.07,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M.7,22.2c0,.18-.05.39-.05.4s0,.21,0,.28l0,.66c0,.08,0,.11.12.08l.25-.12a.28.28,0,0,0,.14-.21L4.45,22l0-4.82A7.08,7.08,0,0,0,.7,22.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4.45 21.88 11.77 24.96 7.85 26.88 1.05 23.28 4.45 21.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M22.71,11.59l0,0h0l-.07,0,7.33,4.26.11,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27.44,17h0l-7.31-4.25h0l-.07,0h0l0,0h-.4l-.06,0,.63.37,1,.6.85.49,1.14.67,1.14.66.85.5,1,.6.63.37h0l.31.18.07,0h.4l0,0,0,0,.07,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "28.95 13.02 21.63 8.77 21.54 6.72 28.86 10.98 28.95 13.02"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M26.69,13.86,19.36,9.6l2.26-.83L29,13l-2.27.83Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.45 15.66 26.45 16.26 26.62 16.16 26.62 15.58 26.45 15.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "26.55 15.81 26.55 16.05 26.62 16.02 26.62 15.78 26.55 15.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M27,15.54c0-.08-.05-.11-.12-.08l-.26.12v.57l.27-.15a.27.27,0,0,0,.12-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M28.14,19.36s0-.74,0-1a1.09,1.09,0,0,0-.48-1l-.31-.08h0l-7.33-4.26a1,1,0,0,1,.44.92c0,.23,0,.88,0,.92l7.33,4.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M27.19,17.06h.37l0,0h0l.07,0,0,0L27.44,17h0l-.07,0h0l-.05,0h-.41l-.06,0,.31.18.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M26.51,18.16a3,3,0,0,0-1.35,2.34c0,.86.61,1.21,1.36.78a3,3,0,0,0,1.35-2.34C27.87,18.07,27.26,17.73,26.51,18.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M25.91,21.45c-.45,0-.73-.36-.73-.94a3,3,0,0,1,1.34-2.33,1.2,1.2,0,0,1,.6-.18c.45,0,.73.36.73.94a3,3,0,0,1-1.34,2.33,1.22,1.22,0,0,1-.6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M25.91,21.43c-.44,0-.71-.36-.72-.93a2.94,2.94,0,0,1,1.33-2.31,1.2,1.2,0,0,1,.59-.18c.44,0,.72.36.72.93a3,3,0,0,1-1.34,2.31,1.2,1.2,0,0,1-.59.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M26.48,17.49h0l-.07,0-.07,0-.08,0H26l-.12,0-.16.05-.19.09a2.23,2.23,0,0,0-.45.35l-.15.16-.11.13-.09.12-.08.12-.07.11-.06.12-.06.11-.05.12,0,.12,0,.13,0,.14c0,.05,0,.11,0,.16s0,.13,0,.19a2.19,2.19,0,0,0,0,.27,1,1,0,0,0,.4.87l1,.58a1,1,0,0,1-.4-.87,2.43,2.43,0,0,1,0-.27c0-.06,0-.13,0-.19l0-.16,0-.14,0-.13,0-.12.05-.12.06-.12.06-.11.07-.11.08-.12.09-.12.11-.13.15-.16a2.2,2.2,0,0,1,.45-.35l.19-.09.16-.06L27,18h.27l.08,0,.07,0,.07,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M26.51,18.8a1.76,1.76,0,0,0-.8,1.38c0,.51.36.71.8.46a1.76,1.76,0,0,0,.8-1.38C27.32,18.75,27,18.54,26.51,18.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M26.51,18.73c.48-.27.87-.05.87.49a1.9,1.9,0,0,1-.86,1.49c-.48.28-.86.05-.87-.49A1.9,1.9,0,0,1,26.51,18.73Zm0,1.91a1.76,1.76,0,0,0,.8-1.38c0-.51-.36-.72-.81-.46a1.76,1.76,0,0,0-.8,1.38c0,.51.36.71.8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M26.25,19l0,0h0l0,0h0l0,0h0l.05,0h0l.07,0h.42l-.08,0-.11-.07a.92.92,0,0,0-.23.1A1.37,1.37,0,0,0,26.25,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M25.93,20.52h0l0,0v0l0,0h0l0-.06v0l0,0v-.09h0v-.1s0,0,0,0,0,0,0-.06h0v-.08h0v0a1.34,1.34,0,0,0-.06.38.89.89,0,0,0,0,.23l.2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M25.78,19.79v0h0a.71.71,0,0,0,0,.08v0a1.17,1.17,0,0,0,0,.13s0,0,0,0v.16l0,0v0l0,.07h0l0,0v0l0,0h0a.36.36,0,0,0,.17.06h.06l0,0h0l0,0h0l0,0h0l0,0v0l0,0v-.09h0a.41.41,0,0,1,0-.05v0h0s0,0,0-.05V20h0v0h0v-.08h0v0l0,0h0v0l0,0h0v-.07h0v0l0,0v0h0v0l0,0v0h0v0l0,0v0h0l0,0,0,0h0l0-.05h0l0,0h0l0,0,0,0h0l0,0h0l0,0h0l0,0,0,0h.06l.05,0h.29l0,0h0l0,0v0h0v0l0,0-.1-.16h0l0,0,0,0,0,0,0,0,0,0h-.32l-.05,0h0l-.09,0-.06,0h0l0,0h0l0,0,0,0A1.9,1.9,0,0,0,25.78,19.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M27.09,19h0l0,0h0l0,0h-.22l-.06,0h-.06l0,0,0,0-.06,0h0l0,0h0l0,0,0,0,0,0h0l-.05.06h0l-.05.06h0l0,.07h0l0,.07h0l0,.07h0l0,.07h0l0,.08h0l0,.07h0l0,.07h0V20h0v.09s0,0,0,.06,0,0,0,0v.14l0,0v0l0,0h0l0,0h0l0,0h0l0,0h.12a.55.55,0,0,0,.33-.09,1.41,1.41,0,0,0,.64-1.11.52.52,0,0,0-.11-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M26.21,20.2a.06.06,0,0,1,.08,0,.14.14,0,0,1,0,.16l-.05.05a.06.06,0,0,1-.07,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M26.6,19.43c.16-.09.29,0,.29.17a.63.63,0,0,1-.29.49c-.16.09-.29,0-.29-.16A.63.63,0,0,1,26.6,19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M26.45,19.43l0,0a.19.19,0,0,0,.06-.17s0,0-.09,0l0,0a.18.18,0,0,0-.06.17S26.41,19.45,26.45,19.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M26.75,20.09l0,0a.19.19,0,0,0-.06.17s.05,0,.09,0l0,0a.18.18,0,0,0,.06-.17S26.79,20.07,26.75,20.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M26.45,20.26h0s.08,0,.06.1a.21.21,0,0,1-.09.12h0s-.07,0-.06-.1A.2.2,0,0,1,26.45,20.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M26.12,19.93s.09,0,.09.05a.22.22,0,0,1-.09.16c-.05,0-.09,0-.09-.05A.21.21,0,0,1,26.12,19.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M26.75,19h0c.05,0,.08,0,.06.1a.2.2,0,0,1-.09.12h0s-.07,0-.06-.1A.2.2,0,0,1,26.75,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M26.21,19.55h.05s.05.07,0,.14a.19.19,0,0,1-.08.09h-.05s-.05-.07,0-.14A.2.2,0,0,1,26.21,19.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M27,19.74H27a.19.19,0,0,0-.07.09c0,.06,0,.13,0,.13H27a.22.22,0,0,0,.07-.09C27.09,19.81,27.08,19.75,27,19.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M27.13,19.36h-.06a.21.21,0,0,0-.07.09c0,.06,0,.12,0,.14h.05a.17.17,0,0,0,.08-.09C27.18,19.44,27.17,19.37,27.13,19.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M27,19.1a.06.06,0,0,1,.07,0s0,.1,0,.16l-.05,0a.06.06,0,0,1-.07,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.21 20.19 26.09 20.12 26.06 20.08 26.18 20.15 26.21 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.18 20.15 26.06 20.08 26.09 20 26.21 20.07 26.18 20.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.21 20.07 26.09 20 26.15 19.96 26.27 20.03 26.21 20.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.27 20.03 26.31 20.08 26.27 20.15 26.21 20.19 26.18 20.15 26.21 20.07 26.27 20.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.3 19.81 26.18 19.74 26.15 19.7 26.27 19.77 26.3 19.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.27 19.77 26.15 19.7 26.18 19.62 26.3 19.69 26.27 19.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.3 19.69 26.18 19.62 26.24 19.58 26.37 19.66 26.3 19.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.37 19.66 26.4 19.7 26.37 19.78 26.3 19.81 26.27 19.77 26.3 19.69 26.37 19.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.55 19.48 26.42 19.41 26.39 19.36 26.51 19.43 26.55 19.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.51 19.43 26.39 19.36 26.42 19.28 26.55 19.35 26.51 19.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.55 19.35 26.42 19.28 26.48 19.25 26.61 19.32 26.55 19.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.61 19.32 26.64 19.36 26.61 19.44 26.55 19.48 26.51 19.43 26.55 19.35 26.61 19.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "27.08 19.37 26.96 19.3 26.93 19.25 27.05 19.32 27.08 19.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "27.05 19.32 26.93 19.25 26.96 19.17 27.08 19.24 27.05 19.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "27.08 19.24 26.96 19.17 27.02 19.14 27.14 19.21 27.08 19.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.14 19.21 27.17 19.25 27.14 19.33 27.08 19.37 27.05 19.32 27.08 19.24 27.14 19.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.84 19.3 26.72 19.23 26.69 19.19 26.81 19.26 26.84 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.81 19.26 26.69 19.19 26.72 19.11 26.84 19.18 26.81 19.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.84 19.18 26.72 19.11 26.78 19.08 26.9 19.15 26.84 19.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.9 19.15 26.93 19.19 26.9 19.27 26.84 19.3 26.81 19.26 26.84 19.18 26.9 19.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "27.17 19.64 27.05 19.57 27.02 19.52 27.14 19.59 27.17 19.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "27.14 19.59 27.02 19.52 27.05 19.44 27.17 19.51 27.14 19.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "27.17 19.51 27.05 19.44 27.11 19.41 27.23 19.48 27.17 19.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.23 19.48 27.27 19.52 27.23 19.6 27.17 19.64 27.14 19.59 27.17 19.51 27.23 19.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "27.08 20.01 26.96 19.94 26.93 19.9 27.05 19.97 27.08 20.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "27.05 19.97 26.93 19.9 26.96 19.82 27.08 19.89 27.05 19.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "27.08 19.89 26.96 19.82 27.02 19.79 27.14 19.86 27.08 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "27.14 19.86 27.18 19.9 27.14 19.98 27.08 20.01 27.05 19.97 27.08 19.89 27.14 19.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.84 20.35 26.72 20.28 26.69 20.24 26.81 20.31 26.84 20.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.81 20.31 26.69 20.24 26.72 20.16 26.84 20.23 26.81 20.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.84 20.23 26.72 20.16 26.78 20.12 26.9 20.19 26.84 20.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.9 20.19 26.93 20.24 26.91 20.32 26.84 20.35 26.81 20.31 26.84 20.23 26.9 20.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.55 20.52 26.43 20.45 26.39 20.41 26.52 20.48 26.55 20.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.52 20.48 26.39 20.41 26.43 20.33 26.55 20.4 26.52 20.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.55 20.4 26.43 20.33 26.49 20.3 26.61 20.37 26.55 20.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.61 20.37 26.64 20.41 26.61 20.49 26.55 20.52 26.52 20.48 26.55 20.4 26.61 20.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "26.31 20.46 26.18 20.39 26.15 20.35 26.28 20.42 26.31 20.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "26.28 20.42 26.15 20.35 26.18 20.27 26.31 20.34 26.28 20.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "26.31 20.34 26.18 20.27 26.25 20.23 26.37 20.3 26.31 20.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "26.37 20.3 26.4 20.35 26.37 20.43 26.31 20.46 26.28 20.42 26.31 20.34 26.37 20.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M26.79,16.92l-.84.49-.28.16-.06,0h0l0,0,0,0,0,0,0,0h0l-.07.07h0l-.07.09h0v0l-.06.08h0l-.07.11h0l-.08.13h0l-.09.16h0v0l0,.06,0,0,0,0v0h0l0,.07h0v0l0,.06h0v0l0,.08V19l0,.07v.15l0,.07v.06h0l0,.11v0l0,.11v0l0,.12v0h0l0,.15v0s0,.09,0,.14v.06c0,.05,0,.11,0,.16v0c0,.07,0,.14,0,.21a.49.49,0,0,0,0,.05c0,.06,0,.11,0,.17v.06c0,.07,0,.15,0,.23l.31.18c0-.08.47-2.63.47-2.63l.09-.17.92-.9.84-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M27.1,17.1c.52-.3,1.22.39,1.22.93v1.22l-.18.11s0-.69,0-.91c0-.91-.71-1.16-1.08-.95l-.65.36a2.9,2.9,0,0,0-.46.32,3.31,3.31,0,0,0-.82,1.46A5.7,5.7,0,0,0,25,21.18l-.19.11a5.64,5.64,0,0,1,.37-2.43A2.78,2.78,0,0,1,26,17.75l.28-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M26.79,16.92h0l-7.33-4.26-.84.49-.28.16-.06,0h0l0,0,0,0,0,0h0l0,0h0l-.07.07h0l-.07.09h0v0l-.06.08h0l-.08.11h0l-.08.13h0l-.09.16h0v0l0,.07,0,0,0,.05v0l0,.07h0v0l0,.06h0v0l0,.08v0h0v0l0,.07v0l0,.05v0l0,.07v.05h0l0,.11v0l0,.12v0l0,.12v0l0,.15v.18a.39.39,0,0,0,0,0c0,.06,0,.12,0,.18v0c0,.07,0,.14,0,.21v.05c0,.06,0,.11,0,.17v.06c0,.07,0,.15,0,.23l7.33,4.26h0l.3.18c0-.08,0-.16,0-.23V21c0-.06,0-.11,0-.17s0,0,0-.05,0-.14,0-.2v0c0-.07,0-.12,0-.17v-.05s0-.09,0-.14v0l0-.16V19.8l0-.12v0l0-.12v-.06l0-.06v-.06l0-.06v0l0-.07v-.07l0-.08v0l0-.08h0l0-.07v0l0-.08h0l0-.09h0l.09-.17h0l.08-.13h0l.07-.11,0,0,.06-.08v0l.07-.09,0,0,.07-.07,0,0,0,0,0,0,0,0,0,0h0l.07,0,.28-.16.84-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M30,15.92c0-.06,0-.09-.06-.06l-.07,0v-.25l0,0-.29.16-1.5.87a.27.27,0,0,1-.32,0l-.39-.19c-.1,0-.2-.06-.41.06l-.12.07.12-.07-1.3.75v.25l.28-.16.84-.49a.7.7,0,0,1,.8.15,1.07,1.07,0,0,1,.43.29l.16.21,1-.22-.87.5h0l.44-.25.43.25-.84.49v.56l.77-.45,1-.92C30,17.46,30,16,30,15.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M28.26,17.63l.17-.1s0,0,0,0v.08a.07.07,0,0,1,0,.06l-.16.09,0,.07.87-.5v-.16h0c0-.06,0-.18,0-.18l-1,.57.05.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.32,18.34l.84-.49-.43-.25-.44.25a.75.75,0,0,1,0,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M29.16,17l-.43-.25-.72.42v.2a1.47,1.47,0,0,1,.15.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M28.46,17.63v-.08s0,0,0,0l-.17.1,0,0,0,.11.16-.09A.07.07,0,0,0,28.46,17.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "29.16 17.85 28.74 17.6 29.16 17.35 29.16 17.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "29.16 16.99 28.74 16.75 29.16 16.5 29.16 16.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "25.67 17.57 18.34 13.31 18.34 13.06 25.67 17.32 25.67 17.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "22.99 5.88 29.68 10.6 29.87 12.9 22.6 8.37 22.99 5.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M22.11,4h0l-.06,0-.08,0-.12,0h-.2l-.16,0-.17,0L21.13,4,21,4,16.89,6l7.33,4.26,4.15-2,.09,0,.19-.07.17,0h.35l.12,0,.09,0,.06,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M24.22,10.29l4.15-2a1.41,1.41,0,0,1,.81-.15c.3.06.44.15.53.53l.16.95-.09.18L25,12.56a.52.52,0,0,0-.25.3l-.16,3.47,0,.36L24.53,18l-.28.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M30,13c0-.08,0-.1-.14-.07l-.44.16-.16-2.22.42-.24.31-.18v-.31l-.07-.29h-.14L25,12.56a.53.53,0,0,0-.25.3L24.62,16l0,.7L24.53,18l1.14-.66,1.18-.68-.44.25h0l.56-.32c.21-.12.31-.11.41-.06l.39.19a.28.28,0,0,0,.32,0l1.07-.62.43-.25.29-.16,0,0,.1-.06Zm-3.32.88V12.23L28.86,11,29,13Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "29.68 10.6 29.87 12.9 29.43 13.06 29.26 10.84 29.68 10.6"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M28.86,11,29,13l-2.27.83V12.23Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.68,12.23v1.62L29,13l-.09-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M26.64,12.21v1.71l.06,0L29,13.06h0l-.1-2.15Zm0,1.65V12.23L28.86,11,29,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M29,10.68v0c0-.09,0-.14,0-.14h0L26.44,12v4.86l.5-.28a.61.61,0,0,1,.3-.1.36.36,0,0,1,.15,0h0l.37.18a.3.3,0,0,0,.14.05h0a.25.25,0,0,0,.13,0l1.05-.61V13.17Zm0,2.39-2.27.83-.06,0V12.21L28.9,10.9l.1,2.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M29.15,13.16c-.56.21-1.88.7-2.75,1v-2L29,10.66Zm-2.46.69L29,13l-.09-2-2.18,1.26v1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M26.4,12.19v2l-.74.26c-.56.17-.55-.29-.56-.51s0-.71,0-.81a.32.32,0,0,1,.16-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M25.13,13.87c0-.22,0-.71,0-.81a.37.37,0,0,1,0-.13.34.34,0,0,0-.07.18c0,.1,0,.59,0,.81s0,.69.56.51l.74-.26c-.34.12-.58.17-.71.2C25.14,14.55,25.14,14.09,25.13,13.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M24.7,16l.14-3.12a.52.52,0,0,1,.25-.3l4.68-2.81L25,12.56a.52.52,0,0,0-.25.3L24.62,16l0,.7L24.53,18l.14-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M24.68,16.29c.24-.11,4.73-2.18,4.85-2.23s.21.61,0,.75l-4.94,2.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M24.6,16.41l1.8-.83,2.75-1.26.38-.17c.09,0,.14.09.15.24,0-.19,0-.37-.15-.33l-.38.17-2.75,1.26-1.8.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M29.5,14.65l-5,2.84v.17l5-2.85a.61.61,0,0,0,.18-.54A.5.5,0,0,1,29.5,14.65Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "28.46 16.69 24.19 17.91 24.19 18.11 28.46 16.89 30.09 15.67 30.08 15.47 28.46 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "30.08 15.47 30.09 15.47 30.03 13.44 24.19 15.88 24.19 16.08 30.03 13.64 30.08 15.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "30.03 13.64 24.19 16.08 24.19 17.91 28.46 16.69 30.08 15.47 30.03 13.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M24.22,10.29l4.15-2a1.41,1.41,0,0,1,.81-.15c.3.06.44.15.53.53l.16.95-.09.18L25,12.56a.52.52,0,0,0-.25.3l-.16,3.47,0,.36L24.53,18l-.28.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M29.15,13.17h0L29,10.66h0c0-.1,0-.24-.13-.18L26.4,11.94v5l.56-.32c.21-.12.31-.11.41-.06l.39.19a.27.27,0,0,0,.32,0l1.07-.62Zm-1.09,3.5a.25.25,0,0,1-.13,0h0a.3.3,0,0,1-.14-.05l-.37-.18h0a.36.36,0,0,0-.15,0,.61.61,0,0,0-.3.1l-.5.28V12l2.49-1.44h0s0,0,0,.14v0l.11,2.49v2.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M18.1,24.64V24.3s0-.1,0-.14,0-.11,0-.18a1.57,1.57,0,0,0-.07-.31,1.14,1.14,0,0,0-.12-.25.89.89,0,0,0-.26-.27l0,0L10.4,18.95l0,0a.85.85,0,0,1,.26.27,1.15,1.15,0,0,1,.12.25,1.79,1.79,0,0,1,.07.31c0,.08,0,.18,0,.18s0,.11,0,.15v.34s0,.11,0,.24l7.21,4.19C18.1,24.75,18.1,24.66,18.1,24.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M17.55,23.1l7.32-4.22a6.32,6.32,0,0,0-.3,2.26L18.1,24.88c0-.13,0-.22,0-.24V24.3s0-.1,0-.14,0-.11,0-.18a1.57,1.57,0,0,0-.07-.31,1.14,1.14,0,0,0-.12-.25.89.89,0,0,0-.26-.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M12.74,22s0-.09,0-.13v-.34s0-.1,0-.14a2.3,2.3,0,0,0-.09-.48.84.84,0,0,0-.27-.36l-.06,0-2.14-1.24.06,0a.83.83,0,0,1,.27.36,2.08,2.08,0,0,1,.09.48s0,.1,0,.14v.47a0,0,0,0,0,0,0l2.14,1.24A0,0,0,0,1,12.74,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M11.26,20.86A3,3,0,0,0,9.91,23.2c0,.86.61,1.21,1.36.77a3,3,0,0,0,1.35-2.34C12.62,20.78,12,20.43,11.26,20.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M10.66,24.15c-.45,0-.73-.36-.73-.94a3,3,0,0,1,1.34-2.33,1.21,1.21,0,0,1,.6-.18c.45,0,.73.36.73.94A3,3,0,0,1,11.26,24a1.21,1.21,0,0,1-.6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M10.66,24.13c-.44,0-.72-.36-.72-.93a3,3,0,0,1,1.34-2.31,1.21,1.21,0,0,1,.59-.18c.44,0,.71.36.72.93a2.94,2.94,0,0,1-1.34,2.31,1.18,1.18,0,0,1-.59.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M11.23,20.19h0l-.07,0-.07,0-.08,0h-.27l-.12,0-.16.06-.19.09a2.23,2.23,0,0,0-.45.35l-.15.16-.11.13L9.46,21l-.08.11-.07.12-.06.11-.06.12-.06.12,0,.12,0,.13L9,22l0,.16c0,.06,0,.12,0,.19a2.24,2.24,0,0,0,0,.27.94.94,0,0,0,.4.87l1,.58a1,1,0,0,1-.39-.87,1.87,1.87,0,0,1,0-.27c0-.06,0-.12,0-.19l0-.16,0-.14,0-.13,0-.12.05-.12.06-.11.06-.11.07-.11.08-.12.09-.12.11-.13.15-.16a2.26,2.26,0,0,1,.45-.35l.19-.09.16-.06.12,0H12l.08,0,.07,0,.07,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M11.26,21.5a1.76,1.76,0,0,0-.8,1.38c0,.51.36.71.8.46a1.77,1.77,0,0,0,.8-1.39C12.06,21.45,11.7,21.24,11.26,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M11.26,21.43c.48-.27.87-.05.87.49a1.91,1.91,0,0,1-.86,1.49c-.48.27-.87.05-.87-.49A1.9,1.9,0,0,1,11.26,21.43Zm0,1.91a1.77,1.77,0,0,0,.8-1.39c0-.51-.36-.71-.8-.46a1.76,1.76,0,0,0-.8,1.38c0,.51.36.71.8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M11,21.7l0,0h0l0,0h0l0,0h0l0,0h0l.07,0h.39l0,0h0l-.08,0-.11-.07a.83.83,0,0,0-.23.09A1.3,1.3,0,0,0,11,21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M10.67,23.22h0l0,0h0l0-.05h0l0-.06v0l0,0v-.08h0v-.21h0v-.08h0v0a1.37,1.37,0,0,0-.06.38.79.79,0,0,0,0,.23l.2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M10.52,22.49v0h0v.1a1.09,1.09,0,0,0,0,.13.25.25,0,0,0,0,0V23l0,0v0l0,.06h0l0,0h0l0,0h0a.33.33,0,0,0,.18.06h.06l0,0h0l0,0h0l0,0h0l0,0h0l0,0V23h0v-.1s0,0,0-.06v-.11h0a.25.25,0,0,1,0-.05v0h0v0h0v0l0,0h0v0l0,0h0v0l0,0h0v0l0,0v0h0v0l0,0v0h0l0,0v0l0,0h0v0l0,0h0l0,0h0l0,0h0l0,0,0,0h0l0,0h0l0,0h0l0,0h.43l0,0h0l0,0v0h0l0,0h0l-.1-.16h0l0,0,0,0h0l0,0h0l0,0h-.29l-.05,0h0l-.09,0-.06,0h0l0,0h0l0,0,0,0A1.91,1.91,0,0,0,10.52,22.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M11.84,21.71h0l0,0h0l0,0h-.22l-.06,0h-.09l0,0-.06,0h0l0,0h0l0,0,0,0,0,0h0L11,22h0l0,.06h0l0,.07h0l0,.07h0l0,.07h0l0,.07h0l0,.08h0l0,.07h0l0,.07v0a.44.44,0,0,0,0,.07h0a.44.44,0,0,0,0,.07v0s0,0,0,.07,0,0,0,0v.21l0,0h0l0,0h0l0,0h0l0,0H11a.56.56,0,0,0,.33-.08A1.42,1.42,0,0,0,12,22.09a.51.51,0,0,0-.11-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M11,22.9a.06.06,0,0,1,.08,0s0,.1,0,.16l-.05.05a.06.06,0,0,1-.07,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M11.34,22.13c.16-.09.29,0,.29.16a.63.63,0,0,1-.29.5c-.16.09-.29,0-.29-.16A.63.63,0,0,1,11.34,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M11.19,22.13l0,0a.19.19,0,0,0,.06-.17s0,0-.09,0l0,0a.19.19,0,0,0-.06.17S11.15,22.15,11.19,22.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M11.49,22.79l0,0a.18.18,0,0,0-.06.17s0,0,.09,0l0,0a.19.19,0,0,0,.06-.17A.06.06,0,0,0,11.49,22.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M11.19,23h0s.08,0,.06.1a.2.2,0,0,1-.09.12h0s-.08,0-.06-.1A.21.21,0,0,1,11.19,23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M10.86,22.63c.05,0,.09,0,.09.05a.2.2,0,0,1-.09.16s-.09,0-.09-.05A.2.2,0,0,1,10.86,22.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M11.49,21.74h0s.08,0,.06.1a.21.21,0,0,1-.09.12h0s-.08,0-.06-.1A.2.2,0,0,1,11.49,21.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M11,22.25H11s.05.07,0,.14a.22.22,0,0,1-.08.09H10.9s0-.07,0-.14A.2.2,0,0,1,11,22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M11.78,22.44h-.05a.19.19,0,0,0-.08.09c0,.07,0,.13,0,.14h.06a.2.2,0,0,0,.07-.09C11.84,22.51,11.82,22.45,11.78,22.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M11.87,22.06h-.05a.19.19,0,0,0-.07.08c0,.06,0,.13,0,.14h.05a.22.22,0,0,0,.07-.09C11.93,22.14,11.92,22.08,11.87,22.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M11.73,21.81a.06.06,0,0,1,.07,0s0,.1,0,.16l-.05,0a.06.06,0,0,1-.08,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "10.96 22.89 10.84 22.82 10.8 22.78 10.93 22.85 10.96 22.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "10.93 22.85 10.8 22.78 10.84 22.7 10.96 22.77 10.93 22.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "10.96 22.77 10.84 22.7 10.89 22.66 11.02 22.73 10.96 22.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.02 22.73 11.05 22.78 11.02 22.86 10.96 22.89 10.93 22.85 10.96 22.77 11.02 22.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.05 22.51 10.93 22.44 10.89 22.4 11.02 22.47 11.05 22.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.02 22.47 10.89 22.4 10.93 22.32 11.05 22.39 11.02 22.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.05 22.39 10.93 22.32 10.99 22.29 11.11 22.36 11.05 22.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.11 22.36 11.14 22.4 11.11 22.48 11.05 22.51 11.02 22.47 11.05 22.39 11.11 22.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.29 22.18 11.17 22.11 11.13 22.06 11.26 22.13 11.29 22.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.26 22.13 11.13 22.06 11.17 21.98 11.29 22.05 11.26 22.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.29 22.05 11.17 21.98 11.23 21.95 11.35 22.02 11.29 22.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.35 22.02 11.38 22.06 11.35 22.14 11.29 22.18 11.26 22.13 11.29 22.05 11.35 22.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.82 22.07 11.7 22 11.67 21.95 11.79 22.02 11.82 22.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.79 22.02 11.67 21.95 11.7 21.87 11.82 21.94 11.79 22.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.82 21.94 11.7 21.87 11.76 21.84 11.88 21.91 11.82 21.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.88 21.91 11.91 21.95 11.89 22.03 11.82 22.07 11.79 22.02 11.82 21.94 11.88 21.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.58 22 11.46 21.93 11.43 21.89 11.55 21.96 11.58 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.55 21.96 11.43 21.89 11.46 21.81 11.58 21.88 11.55 21.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.58 21.88 11.46 21.81 11.52 21.77 11.64 21.85 11.58 21.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.64 21.85 11.68 21.89 11.64 21.97 11.58 22 11.55 21.96 11.58 21.88 11.64 21.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.92 22.34 11.79 22.27 11.77 22.22 11.89 22.29 11.92 22.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.89 22.29 11.77 22.22 11.79 22.14 11.91 22.22 11.89 22.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.91 22.22 11.79 22.14 11.86 22.11 11.98 22.18 11.91 22.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.98 22.18 12.01 22.22 11.98 22.3 11.92 22.34 11.89 22.29 11.91 22.22 11.98 22.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.82 22.71 11.7 22.64 11.67 22.6 11.8 22.67 11.82 22.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.8 22.67 11.67 22.6 11.7 22.52 11.82 22.59 11.8 22.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.82 22.59 11.7 22.52 11.77 22.49 11.89 22.56 11.82 22.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.89 22.56 11.92 22.6 11.89 22.68 11.82 22.71 11.8 22.67 11.82 22.59 11.89 22.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.59 23.05 11.46 22.98 11.43 22.94 11.56 23.01 11.59 23.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.56 23.01 11.43 22.94 11.46 22.86 11.59 22.93 11.56 23.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.59 22.93 11.46 22.86 11.53 22.82 11.65 22.89 11.59 22.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.65 22.89 11.68 22.94 11.65 23.02 11.59 23.05 11.56 23.01 11.59 22.93 11.65 22.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.29 23.22 11.17 23.15 11.14 23.11 11.26 23.18 11.29 23.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.26 23.18 11.14 23.11 11.17 23.03 11.29 23.1 11.26 23.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.29 23.1 11.17 23.03 11.23 23 11.35 23.07 11.29 23.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.35 23.07 11.38 23.11 11.35 23.19 11.29 23.22 11.26 23.18 11.29 23.1 11.35 23.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "11.05 23.16 10.93 23.09 10.9 23.05 11.02 23.12 11.05 23.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "11.02 23.12 10.9 23.05 10.93 22.97 11.05 23.04 11.02 23.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "11.05 23.04 10.93 22.97 10.99 22.93 11.11 23 11.05 23.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "11.11 23 11.14 23.05 11.11 23.13 11.05 23.16 11.02 23.12 11.05 23.04 11.11 23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M9.53,23.76,7.4,22.52a0,0,0,0,0,0,0L9.55,23.8A0,0,0,0,1,9.53,23.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M12.09,20.14h.16l.1,0h0l.1,0L10.34,19h0l-.08,0h0l-.06,0H9.71l-.13,0h0l-.11,0-.08,0h0l-.1,0h0l-.11.06a2.9,2.9,0,0,0-.41.29l-.15.14h0l0,0-.16.17h0l-.11.14,0,0,0,0-.07.09h0l0,.05L8,20.23l0,0,0,0,0,.07,0,0-.05.09,0,.06,0,0,0,.08,0,0,0,0,0,.08,0,0v0l0,.08,0,0,0,.06,0,.1,0,.05,0,.08v0l0,.11,0,.08a.84.84,0,0,0,0,.1v0s0,.08,0,.13v.06c0,.09,0,.2,0,.2s0,.1,0,.14v.34l2.14,1.24v-.34s0-.1,0-.14,0-.11,0-.2,0-.13,0-.19v0c0-.06,0-.12,0-.18l0-.16,0-.08,0-.15,0-.1,0-.08,0-.07,0-.08,0-.07,0-.07.05-.1.07-.12,0-.07,0-.08.05-.07,0-.07.06-.09.05-.07.12-.14h0l.16-.17,0,0,.15-.14a2.71,2.71,0,0,1,.41-.29l.11-.06,0,0,.1,0h0l.08,0,.11,0h0l.13,0h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M11.25,20.37a2.07,2.07,0,0,1,.33-.15,1.36,1.36,0,0,1,.37-.08,1,1,0,0,1,.31,0,.76.76,0,0,1,.26.11.86.86,0,0,1,.15.12.89.89,0,0,1,.13.17,1.12,1.12,0,0,1,.12.27,2.65,2.65,0,0,1,.07.46s0,.1,0,.14v.47a.13.13,0,0,1-.06.1l-.12.07s-.06,0-.06,0,0-.09,0-.13v-.34s0-.1,0-.14a2.3,2.3,0,0,0-.09-.48.84.84,0,0,0-.27-.36.76.76,0,0,0-.55-.14,1.16,1.16,0,0,0-.34.09l-.23.11a2.46,2.46,0,0,0-.41.3,3.18,3.18,0,0,0-.38.42,3.7,3.7,0,0,0-.3.47,3.51,3.51,0,0,0-.28.7,2.63,2.63,0,0,0-.08.39c0,.1,0,.21,0,.21s0,.1,0,.14v.2s0,.1,0,.14a.14.14,0,0,1-.06.11l-.12.07s-.06,0-.06,0v-.34s0-.1,0-.14,0-.11,0-.2a2.84,2.84,0,0,1,.07-.39,3.73,3.73,0,0,1,.11-.39,4.07,4.07,0,0,1,.26-.57,4.27,4.27,0,0,1,.37-.57,3.62,3.62,0,0,1,.48-.5A2.71,2.71,0,0,1,11.25,20.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "24.87 18.88 22.83 17.69 23.29 17.43 20.28 15.68 19.83 15.95 17.67 14.69 10.35 18.92 12.51 20.17 8.47 22.51 11.48 24.25 15.51 21.92 17.55 23.1 24.87 18.88"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M17.86,25v-.47s0-.1,0-.14a2.33,2.33,0,0,0-.09-.48.83.83,0,0,0-.27-.36l-.06,0-2.14-1.24.06,0a.86.86,0,0,1,.27.36,2.26,2.26,0,0,1,.09.48s0,.1,0,.14v.47a0,0,0,0,0,0,0L17.87,25A0,0,0,0,1,17.86,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M16.38,23.8A3,3,0,0,0,15,26.15c0,.86.61,1.21,1.36.77a3,3,0,0,0,1.35-2.34C17.73,23.72,17.12,23.37,16.38,23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M15.78,27.09c-.45,0-.73-.36-.74-.94a3,3,0,0,1,1.34-2.33,1.2,1.2,0,0,1,.6-.18c.45,0,.73.36.73.94a3,3,0,0,1-1.34,2.33,1.23,1.23,0,0,1-.6.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M15.78,27.07c-.44,0-.72-.35-.72-.93a2.94,2.94,0,0,1,1.33-2.31,1.18,1.18,0,0,1,.59-.18c.44,0,.72.35.72.93a3,3,0,0,1-1.33,2.31,1.22,1.22,0,0,1-.59.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M16.34,23.13h0l-.07,0-.07,0-.08,0h-.27l-.12,0-.16.05-.19.1a2.16,2.16,0,0,0-.45.35l-.15.16-.11.14-.09.12-.08.12-.07.11-.06.11-.06.12-.05.12-.05.12,0,.13,0,.14,0,.16c0,.06,0,.13,0,.19a1.89,1.89,0,0,0,0,.26,1,1,0,0,0,.4.87l1,.58a1,1,0,0,1-.4-.87,2.22,2.22,0,0,1,0-.27c0-.06,0-.12,0-.19s0-.1,0-.16l0-.14,0-.13,0-.12L15.3,25l.06-.12.06-.11.07-.12.08-.12.09-.12.11-.13.15-.16a2.3,2.3,0,0,1,.45-.35l.19-.09.16-.05.12,0h.27l.08,0,.07,0,.07,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M16.38,24.44a1.77,1.77,0,0,0-.8,1.39c0,.51.36.71.8.46a1.76,1.76,0,0,0,.8-1.38C17.18,24.39,16.82,24.19,16.38,24.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M16.38,24.37c.48-.27.86-.05.87.49a1.9,1.9,0,0,1-.86,1.49c-.48.27-.86.05-.86-.49A1.9,1.9,0,0,1,16.38,24.37Zm0,1.91a1.76,1.76,0,0,0,.8-1.38c0-.51-.36-.71-.81-.46a1.77,1.77,0,0,0-.8,1.39c0,.51.36.71.8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M16.12,24.65l0,0h0l0,0,0,0h0l0,0,0,0h0l.05,0h0l.07,0h.39l0,0h0l-.08,0-.11-.07a1,1,0,0,0-.23.09A1.44,1.44,0,0,0,16.12,24.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M15.79,26.16h0l0,0,0,0,0,0h0l0-.06v0l0,0v-.09h0a.27.27,0,0,1,0-.05v0s0,0,0-.05a.58.58,0,0,1,0-.06v0h0V25.5h0v0a1.34,1.34,0,0,0-.06.38.83.83,0,0,0,0,.23l.2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M15.64,25.43v.05h0l0,.09v0a1,1,0,0,0,0,.13s0,0,0,0a.27.27,0,0,0,0,.05v.11l0,0v0l0,.06h0l0,0h0l0,0h0a.36.36,0,0,0,.17.06H16l0,0h0l0,0h0l0,0h0l0-.05v-.15h0v-.09a.43.43,0,0,1,0,0v-.11h0v-.09h0v0h0v-.07h0v0l0,0h0l0,0,0,0h0v0l0,0v0h0l0,0,0,0v0h0v0l0,0v0h0l0,0,0,0h0l0,0h0l0,0h0l0,0,0,0h0l0,0h0l0,0h0l0,0h.09l.05,0H17l0,0h0l0,0h0l-.1-.15h0l0,0,0,0,0,0,0,0h0l0,0h-.29l-.06,0h0l-.09,0-.06,0,0,0,0,0,0,0,0,0,0,0A1.89,1.89,0,0,0,15.64,25.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M17,24.66h0l0,0h0l0,0h-.22l-.06,0h0l0,0h0l0,0-.06,0h0l0,0h0l0,0,0,0,0,0h0l-.05.06h0L16.1,25h0l0,.07h0l0,.07h0l0,.07h0l0,.08h0l0,.07h0l0,.07h0l0,.07v.09h0v.06h0s0,.05,0,.07a.36.36,0,0,0,0,0V26l0,.05h0l0,0h0l0,0h0l0,0h.12a.54.54,0,0,0,.32-.08A1.41,1.41,0,0,0,17.1,25a.52.52,0,0,0-.11-.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M16.07,25.84a.06.06,0,0,1,.07,0s0,.1,0,.16l-.06.05a.06.06,0,0,1-.08,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M16.46,25.07c.16-.09.29,0,.29.17a.63.63,0,0,1-.29.49c-.16.09-.29,0-.29-.17A.63.63,0,0,1,16.46,25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M16.31,25.07l0,0a.19.19,0,0,0,.06-.17s-.05,0-.09,0l0,0a.18.18,0,0,0-.06.17S16.27,25.09,16.31,25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M16.61,25.74l0,0a.18.18,0,0,0-.06.17s0,0,.09,0l0,0a.17.17,0,0,0,.06-.17S16.65,25.71,16.61,25.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M16.31,25.91h0s.07,0,.06.1a.21.21,0,0,1-.09.13h0s-.08,0-.06-.1A.21.21,0,0,1,16.31,25.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M16,25.57s.09,0,.09.05a.21.21,0,0,1-.09.16c-.05,0-.09,0-.09-.05A.2.2,0,0,1,16,25.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M16.61,24.69h0c.06,0,.08,0,.07.1a.2.2,0,0,1-.09.12h0s-.08,0-.06-.1A.21.21,0,0,1,16.61,24.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M16.07,25.2h.05s0,.07,0,.14a.19.19,0,0,1-.07.09H16s-.05-.07,0-.14A.2.2,0,0,1,16.07,25.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M16.9,25.38h-.05a.2.2,0,0,0-.08.09c0,.06,0,.12,0,.14h.05a.19.19,0,0,0,.07-.09C17,25.46,16.94,25.4,16.9,25.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M17,25h-.05a.19.19,0,0,0-.07.09c0,.07,0,.13,0,.14h.05a.19.19,0,0,0,.07-.09C17,25.08,17,25,17,25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M16.85,24.75a.06.06,0,0,1,.07,0s0,.1,0,.16l-.05.05a.06.06,0,0,1-.08,0s0-.1,0-.16Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.07 25.84 15.95 25.77 15.92 25.72 16.05 25.79 16.07 25.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.05 25.79 15.92 25.72 15.95 25.64 16.07 25.71 16.05 25.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.07 25.71 15.95 25.64 16.02 25.61 16.14 25.68 16.07 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.14 25.68 16.17 25.72 16.14 25.8 16.07 25.84 16.05 25.79 16.07 25.71 16.14 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.17 25.46 16.04 25.39 16.01 25.34 16.14 25.42 16.17 25.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.14 25.42 16.01 25.34 16.04 25.27 16.17 25.34 16.14 25.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.17 25.34 16.04 25.27 16.11 25.23 16.23 25.3 16.17 25.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.23 25.3 16.26 25.34 16.23 25.42 16.17 25.46 16.14 25.42 16.17 25.34 16.23 25.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.41 25.12 16.28 25.05 16.25 25 16.38 25.07 16.41 25.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.38 25.07 16.25 25 16.28 24.93 16.41 25 16.38 25.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.41 25 16.28 24.93 16.34 24.89 16.47 24.96 16.41 25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.47 24.96 16.5 25 16.47 25.09 16.41 25.12 16.38 25.07 16.41 25 16.47 24.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.94 25.01 16.82 24.94 16.79 24.89 16.91 24.97 16.94 25.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.91 24.97 16.79 24.89 16.82 24.82 16.94 24.89 16.91 24.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.94 24.89 16.82 24.82 16.88 24.78 17 24.85 16.94 24.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "17 24.85 17.04 24.89 17 24.97 16.94 25.01 16.91 24.97 16.94 24.89 17 24.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.7 24.95 16.58 24.88 16.55 24.83 16.67 24.91 16.7 24.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.67 24.91 16.55 24.83 16.58 24.75 16.7 24.83 16.67 24.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.7 24.83 16.58 24.75 16.64 24.72 16.76 24.79 16.7 24.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.76 24.79 16.8 24.84 16.77 24.91 16.7 24.95 16.67 24.91 16.7 24.83 16.76 24.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "17.04 25.28 16.91 25.21 16.88 25.17 17.01 25.24 17.04 25.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "17.01 25.24 16.88 25.17 16.91 25.09 17.04 25.16 17.01 25.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "17.04 25.16 16.91 25.09 16.98 25.05 17.1 25.12 17.04 25.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "17.1 25.12 17.13 25.17 17.1 25.25 17.04 25.28 17.01 25.24 17.04 25.16 17.1 25.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.94 25.66 16.82 25.59 16.79 25.54 16.91 25.61 16.94 25.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.91 25.61 16.79 25.54 16.82 25.47 16.94 25.54 16.91 25.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.94 25.54 16.82 25.47 16.88 25.43 17.01 25.5 16.94 25.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "17.01 25.5 17.04 25.54 17.01 25.62 16.94 25.66 16.91 25.61 16.94 25.54 17.01 25.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.71 26 16.58 25.93 16.55 25.88 16.67 25.95 16.71 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.67 25.95 16.55 25.88 16.58 25.8 16.7 25.88 16.67 25.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.7 25.88 16.58 25.8 16.64 25.77 16.77 25.84 16.7 25.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.77 25.84 16.8 25.88 16.77 25.96 16.71 26 16.67 25.95 16.7 25.88 16.77 25.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.41 26.17 16.29 26.1 16.26 26.06 16.38 26.13 16.41 26.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.38 26.13 16.26 26.06 16.29 25.98 16.41 26.05 16.38 26.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.41 26.05 16.29 25.98 16.35 25.94 16.47 26.01 16.41 26.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.47 26.01 16.5 26.06 16.47 26.13 16.41 26.17 16.38 26.13 16.41 26.05 16.47 26.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "16.17 26.11 16.05 26.04 16.02 25.99 16.14 26.06 16.17 26.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "16.14 26.06 16.02 25.99 16.05 25.91 16.17 25.98 16.14 26.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "16.17 25.98 16.05 25.91 16.11 25.88 16.23 25.95 16.17 25.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "16.23 25.95 16.26 25.99 16.23 26.07 16.17 26.11 16.14 26.06 16.17 25.98 16.23 25.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M14.65,26.71l-2.14-1.24a0,0,0,0,0,0,0l2.14,1.24A0,0,0,0,1,14.65,26.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M17.21,23.08h.16l.1,0h0l.1.05L15.46,22h0l-.09,0h0l-.06,0h-.45l-.13,0h0l-.11,0-.08,0h0l-.1,0h0l-.11.06a2.7,2.7,0,0,0-.41.29l-.15.14,0,0h0l-.17.18h0l-.11.14,0,0,0,0-.07.09,0,0,0,0,0,.08,0,0,0,0,0,.07,0,0-.05.09,0,.06,0,0,0,.07,0,0,0,0,0,.08,0,0v0l0,.08,0,0,0,.06,0,.1,0,.05,0,.08v0l0,.11,0,.08,0,.1h0l0,.14v.06c0,.09,0,.2,0,.2s0,.11,0,.15v.34l2.14,1.24v-.34s0-.1,0-.14,0-.11,0-.2l0-.19v0l0-.18,0-.16,0-.08.05-.15,0-.1,0-.08L15,25l0-.08,0-.07,0-.08.05-.1.07-.12,0-.07,0-.07,0-.07,0-.07.06-.09.06-.07L15.6,24h0l.16-.17,0,0,.15-.14a2.68,2.68,0,0,1,.41-.29l.11-.06h0l.1,0h0l.08,0,.11,0h0l.13,0h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M16.37,23.32a2,2,0,0,1,.33-.15,1.45,1.45,0,0,1,.37-.08,1.07,1.07,0,0,1,.3,0,.9.9,0,0,1,.26.11l.15.12a1,1,0,0,1,.13.17,1.34,1.34,0,0,1,.12.27,2.74,2.74,0,0,1,.07.45s0,.1,0,.14v.47a.12.12,0,0,1-.06.09l-.12.07s-.06,0-.06,0v-.47s0-.1,0-.14a2.33,2.33,0,0,0-.09-.48.83.83,0,0,0-.27-.36.79.79,0,0,0-.55-.14,1.36,1.36,0,0,0-.34.09l-.23.11a2.5,2.5,0,0,0-.41.31,3.16,3.16,0,0,0-.38.42,3.48,3.48,0,0,0-.3.47,3.31,3.31,0,0,0-.29.7,2.87,2.87,0,0,0-.08.39c0,.09,0,.2,0,.2s0,.11,0,.15v.33a.14.14,0,0,1-.06.11l-.12.07s-.06,0-.06,0v-.34s0-.1,0-.14,0-.11,0-.2a3.58,3.58,0,0,1,.07-.39,3.86,3.86,0,0,1,.12-.39,4.07,4.07,0,0,1,.26-.57,4,4,0,0,1,.38-.57,3.52,3.52,0,0,1,.47-.5A2.68,2.68,0,0,1,16.37,23.32Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "24.24 18.14 16.91 13.89 16.89 6.04 24.22 10.29 24.24 18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M12.19,18.49h0v0h0l0,0h0l0,0h-.23l0,0a.11.11,0,0,1-.06-.09v.11a.11.11,0,0,0,.06.09l0,0h.23l0,0h.06v-.11A.08.08,0,0,1,12.19,18.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M12.13,18.37a.09.09,0,0,1,0,.18.34.34,0,0,1-.31,0,.09.09,0,0,1,0-.18A.33.33,0,0,1,12.13,18.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "14.39 26.05 7.18 21.86 7.18 21.21 14.42 25.41 14.39 26.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "14.69 24.77 7.48 20.58 8.03 20.27 15.23 24.46 14.69 24.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "14.38 25.39 7.18 21.21 7.48 20.58 14.69 24.77 14.38 25.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M14.69,24.77l.54-.31-.07.13-.15.29c0,.11-.09.21-.13.32a3.72,3.72,0,0,0-.12.4,2.54,2.54,0,0,0,0,.25l-.34.2V25.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M11.6,23.88h0L10,23h0v.4h0l1.57.9h0V23.9Zm0,.37L10,23.36V23l1.53.89Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "11.57 23.9 11.57 24.25 10.04 23.36 10.04 23.01 11.57 23.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "7.58 21.64 7.58 22.06 7.28 21.89 7.28 21.46 7.58 21.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "8.18 21.98 8.18 22.41 7.89 22.24 7.89 21.82 8.18 21.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "8.49 22.16 8.49 22.58 8.18 22.41 8.18 21.98 8.49 22.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M7.25,21.41l1.27.73v.49L7.25,21.9Zm1.24,1.17v-.42L8.18,22l-.3-.17-.3-.18-.3-.17v.42l.3.18.3.18.29.17.31.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "7.89 21.82 7.89 22.24 7.58 22.06 7.58 21.64 7.89 21.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "7.25 21.41 7.31 21.38 8.58 22.11 8.52 22.15 7.25 21.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "8.52 22.15 8.58 22.11 8.58 22.6 8.52 22.64 8.52 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "13.28 24.97 13.28 25.39 12.97 25.21 12.97 24.79 13.28 24.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "14.18 25.49 14.18 25.91 13.88 25.73 13.88 25.31 14.18 25.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M12.94,24.74l1.27.73V26l-1.27-.73Zm1.24,1.17v-.42l-.3-.18-.3-.17L13.28,25,13,24.79v.42l.31.18.29.17.3.17.3.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "13.57 25.14 13.57 25.56 13.28 25.39 13.28 24.97 13.57 25.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "13.88 25.31 13.88 25.73 13.57 25.56 13.57 25.14 13.88 25.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "12.94 24.74 13 24.7 14.27 25.43 14.21 25.47 12.94 24.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "14.21 25.47 14.27 25.43 14.27 25.92 14.21 25.96 14.21 25.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "15.41 19.04 15.41 19.44 14.85 20.17 14.86 19.77 15.41 19.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "14.86 19.77 14.85 20.17 14.53 20.6 14.53 20.2 14.86 19.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "14.53 20.2 14.53 20.6 14.42 20.8 14.42 20.4 14.53 20.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "14.42 20.4 14.42 20.8 14.34 20.84 14.34 20.44 14.42 20.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M14.27,20.83h.07v-.4h-.18v.4a.06.06,0,0,1,0,0h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M14.39,20.47v.14h0v.26a0,0,0,0,1,0,0v-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M14.86,19.77l-.33.43-.4.23a.09.09,0,0,0,0,.16h0a.31.31,0,0,0,.28,0l.4-.23.74-.19c.12.22,0,.47-.26.64a1.7,1.7,0,0,1-1.54,0,.47.47,0,0,1,0-.89A1.7,1.7,0,0,1,14.86,19.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M14.47,20.43l-.08,0s0,.06,0,.08a.2.2,0,0,1-.17,0s0-.07,0-.1a.19.19,0,0,1,.15,0l.08,0,.11-.2-.4.23a.1.1,0,0,0-.06.08.11.11,0,0,0,.06.08h0a.27.27,0,0,0,.15,0,.28.28,0,0,0,.12,0l.18-.1.22-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M16.92,20.54l0,0,.11-.12V20l-.11.12,0,0-.11.11h0l-.1.11,0,0-.11.11,0,0-.06.06,0,0-.06,0,0,0-.06,0,0,0-.06,0,0,0-.09.07h0L16,21l0,0-.05,0,0,0,0,0,0,0-.08,0h0l-.06,0h0l-.09,0h0l-.08,0h0l0,0H15l-.1,0h-.68l-.17,0h-.28l-.07,0h0l-.09,0h0l-.1,0h0l-.12-.05h0l-.12-.06a.89.89,0,0,1-.53-.74c0,.13,0,.27,0,.4a.9.9,0,0,0,.53.74l.12.06h0l.12.05h0l.1,0h0l.09,0h1.69l.08,0h0l.09,0h0l.07,0h0l.08,0,0,0h0l0,0,0,0,.05,0h0l.18-.13h0l.07-.06,0,0,.07-.06,0,0,.07-.06,0,0,.07-.06,0,0h0l.12-.11,0,0,.11-.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M16.82,19.85l-1.26.32c.12.22,0,.47-.26.64a1.7,1.7,0,0,1-1.54,0,.47.47,0,0,1,0-.89,1.7,1.7,0,0,1,1.11-.15l.55-.73-.24-.14a10.36,10.36,0,0,0-1.92.74.78.78,0,0,0,0,1.47,2.79,2.79,0,0,0,2.54,0A5.85,5.85,0,0,0,17.06,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M16,20.36a0,0,0,0,1,0,0,.86.86,0,0,1-.59.67,2.37,2.37,0,0,1-1.09.17,2.09,2.09,0,0,1-.88-.25.77.77,0,0,1-.45-.61c0-.47.65-.86,1.47-.88h.06s0,.08-.06.08a1.4,1.4,0,0,0-1.27.59c-.11.28,0,.56.37.74a1.76,1.76,0,0,0,.68.21,2.18,2.18,0,0,0,1-.12c.35-.14.57-.37.58-.62C15.86,20.34,16,20.33,16,20.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M16.81,10.92a8,8,0,0,0,3.62,6.27c2,1.15,3.62.22,3.62-2.09a8,8,0,0,0-3.62-6.27C18.43,7.68,16.81,8.62,16.81,10.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M3.49,17.84a9.5,9.5,0,0,0,4.3,7.44c2.37,1.37,4.3.26,4.3-2.48a9.5,9.5,0,0,0-4.3-7.44C5.41,14,3.49,15.1,3.49,17.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M23.72,16.08a9.5,9.5,0,0,0-4.3-7.44,3,3,0,0,0-3.06-.29L4.77,15a3,3,0,0,1,3,.31,9.5,9.5,0,0,1,4.3,7.44,3.09,3.09,0,0,1-1.16,2.72l11.49-6.63A3,3,0,0,0,23.72,16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M19.42,8.64A4.31,4.31,0,0,0,18,8.09L6.33,14.81a4.31,4.31,0,0,1,1.46.55,7.85,7.85,0,0,1,2.1,1.85l11.63-6.72A7.85,7.85,0,0,0,19.42,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M23.72,16.08a6.71,6.71,0,0,0-.11-1.15L12,21.65a6.71,6.71,0,0,1,.1,1.15,3.09,3.09,0,0,1-1.16,2.72l11.49-6.63A3,3,0,0,0,23.72,16.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M23.51,12.88l.18.37a4.37,4.37,0,0,0-.39-1L11.24,19.36q.14.3.26.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M23.69,13.26l-.18-.37L11.5,20a7.9,7.9,0,0,1,.58,2.82,5.05,5.05,0,0,1-.06.79l10.36-6a3.56,3.56,0,0,0,1.56-3.35A2.62,2.62,0,0,0,23.69,13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M3.25,18.75A8,8,0,0,0,6.87,25c2,1.15,3.62.22,3.62-2.09a8,8,0,0,0-3.62-6.27C4.87,15.51,3.25,16.44,3.25,18.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M4,19.2a6.28,6.28,0,0,0,2.84,4.92c1.57.91,2.84.17,2.84-1.64a6.28,6.28,0,0,0-2.84-4.92C5.3,16.65,4,17.39,4,19.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M7.25,23.91A6.28,6.28,0,0,1,4.41,19a2.12,2.12,0,0,1,.67-1.73A1.87,1.87,0,0,0,4,19.2a6.28,6.28,0,0,0,2.84,4.92A1.89,1.89,0,0,0,9,24.21,2.15,2.15,0,0,1,7.25,23.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M12.27,22.73a7.91,7.91,0,0,0-.46-2.24,7.83,7.83,0,0,0-3.93,4.93c0,.15-.06.26-.07.29s-.05.39-.05.4,0,.21,0,.28l0,.66c0,.08,0,.11.12.08L8.06,27a.28.28,0,0,0,.14-.21l1.74-.75,1.58-.68a3.24,3.24,0,0,0,.76-2c0-.12,0-.23,0-.36S12.28,22.82,12.27,22.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M6.84,18.38a1.52,1.52,0,0,1,.54,1.26.49.49,0,0,1-.24.41h0l.5-.22a.48.48,0,0,0,.25-.42,1.52,1.52,0,0,0-.54-1.26.48.48,0,0,0-.48-.1l-.51.22A.48.48,0,0,1,6.84,18.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M5.84,18.69c.06-.51.44-.67.85-.37a1.77,1.77,0,0,1,.64,1.47c-.06.51-.44.67-.85.37A1.77,1.77,0,0,1,5.84,18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M6.69,18.32a1.77,1.77,0,0,1,.64,1.47.57.57,0,0,1-.29.48H7l.21-.09a.56.56,0,0,0,.3-.49,1.77,1.77,0,0,0-.64-1.47.56.56,0,0,0-.56-.12l-.22.1A.56.56,0,0,1,6.69,18.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M6.1,18.88c0-.33.28-.43.55-.24a1.14,1.14,0,0,1,.41.95c0,.33-.28.43-.55.24A1.14,1.14,0,0,1,6.1,18.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M6.62,19.78a1.14,1.14,0,0,1-.41-.95.4.4,0,0,1,.14-.28c-.13,0-.23.14-.25.33a1.14,1.14,0,0,0,.41.95.33.33,0,0,0,.41,0A.4.4,0,0,1,6.62,19.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconos32PxFase2B1Generic01);
export default __webpack_public_path__ + "static/media/ICONOS-32PX-FASE-2b.1-GENERIC-01.c2e7218f0f00237bbda61ec32479676f.svg";
export { ForwardRef as ReactComponent };